<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">SMS Router Log Search</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-container>
			<b-card>
				<b-row class="justify-content-center pt-3">
					<b-form @submit="submitSearch" class="justify-content-end">
						<b-form-group
							label-cols="5"
							label-for="search-term"
							:state="!searchDisabled"
							invalid-feedback="Please enter a search term of at least 3 characters."
						>
							<template v-slot:label>
								<p class="font-weight-900">Enter search term:</p>
							</template>
							<b-input-group>
								<b-form-input
									id="search-term"
									v-model="searchTerm"
									placeholder="ex. XYZ,14"
									type="text"
									size="sm"
									class=""
								></b-form-input>
								<b-input-group-append>
									<b-button variant="primary" size="sm" :disabled="searchDisabled || loadingStatus" type="submit">
										Search <i class="fa fa-search"></i>
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</b-form-group>
					</b-form>
				</b-row>
				<b-row class="justify-content-center">
					<p v-if="items">
						Showing <strong class="font-weight-600">{{ totalRows }}</strong> records found containing
						<strong class="font-weight-900"> {{ searchedTerm }} </strong>
					</p>
					<p v-if="loadingStatus">
						Searching for records containing <strong class="font-weight-900">{{ searchedTerm }}</strong
						>...
					</p>
				</b-row>
				<b-card-body id="logs-display" class="p-3 scrollable bg-dark">
					<div class="text-center w-100" v-if="loadingStatus">
						<b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
					</div>
					<b-col cols="12">
						<div v-if="items.length > 0" class="opacity-0.8 p-4 rounded">
							<code>
								<span v-for="(item, index) in items"> 
                                    <p class="text-white">
                                        <strong>[{{ index + 1 }}] - </strong> {{ `${item}` }} <br /> 
                                    </p>
                                </span>
							</code>
						</div>
						<div v-else-if="!loadingStatus && items.length === 0" class="opacity-0.8 p-4 rounded">
							<p class="text-center">No records to display.</p>
						</div>
					</b-col>
				</b-card-body>
                <b-card-footer>
                    <b-row>
                        <b-col>
                            <p>Showing {{ totalRows }} Log Entries</p>
                        </b-col>
                        <b-col>
                            <b-button variant="primary" @click="() => scrollToTop()" >Jump to Top</b-button>
                            <b-button variant="primary" @click="() => scrollToTop(true)" >Jump to Bottom</b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>
			</b-card>
		</b-container>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import initService from "../../../common/api-services/init-service";

export default {
	name: "SmsRouterLogSearch",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - SMS Router Log Search";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			searchTerm: "",
			searchedTerm: "",
			resultLocation: null,
			items: "",
			loadingStatus: false,
			parsingResponse: false,
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		searchDisabled() {
			return this.searchTerm.length < 3;
		},
		totalRows() {
			return this.items.length;
		},
	},
	methods: {
		async submitSearch(event) {
			event.preventDefault();
			this.items = "";
			this.searchedTerm = this.searchTerm;
			this.loadingStatus = true;
			// console.log("Searching for " + this.searchTerm);
			await troubleshootingService
				.getSearchSmsLog(this.searchTerm)
				.then(response => {
					if (response.status) {
						let items = response.message.split("\n");
						this.items = items;
					} else {
						console.log(response.message);
					}

					this.loadingStatus = false;
				})
				.catch(error => {
					console.log(error);
					this.loadingStatus = false;
				});
		},

		scrollToTop(invert=false) {
            if (invert) {
                document.getElementById('logs-display').scrollTop = 9999999;
            } else {
                document.getElementById('logs-display').scrollTop = 0;
            }
        }
	},
};
</script>

<style scoped>
.scrollable {
	height: 50vh;
	overflow-y: scroll;
}
</style>
